import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

const inp = "w-full px-4 py-3 rounded-xl bg-wyd-bg border border-white/10 text-white focus:ring-2 focus:ring-wyd-accent focus:outline-none";
const emptyForm = { current: "", next: "", confirm: "" };

const Field = ({ label, testid, value, onChange }) => (
  <div>
    <label className="overline text-wyd-muted block mb-1.5">{label}</label>
    <input type="password" required data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} className={inp} />
  </div>
);

export const ChangePassword = () => {
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.next.length < 8) { setError("La nuova password deve avere almeno 8 caratteri"); return; }
    if (form.next !== form.confirm) { setError("Le due password non coincidono"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Password aggiornata");
      setForm(emptyForm);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setSaving(false); }
  };

  return (
    <form onSubmit={submit} className="glass rounded-2xl p-6 max-w-md space-y-4" data-testid="change-password-form">
      <div className="flex items-center gap-2 font-display font-bold text-lg"><KeyRound size={18} className="text-wyd-accent" /> Cambia password</div>
      <Field label="Password attuale" testid="current-password-input" value={form.current} onChange={set("current")} />
      <Field label="Nuova password (min. 8 caratteri)" testid="new-password-input" value={form.next} onChange={set("next")} />
      <Field label="Conferma nuova password" testid="confirm-password-input" value={form.confirm} onChange={set("confirm")} />
      {error && <p data-testid="change-password-error" className="text-sm text-red-300">{error}</p>}
      <button data-testid="change-password-submit" disabled={saving}
        className="w-full py-3 rounded-full bg-wyd-accent text-wyd-bg font-semibold hover:glow-magenta transition-shadow duration-300 disabled:opacity-60">
        {saving ? <Loader2 className="animate-spin mx-auto" size={18} /> : "Aggiorna password"}
      </button>
    </form>
  );
};
